export const EMAIL_FIELD_NAME = 'email'
export const EMAIL_FIELD_ID = 'email'
